import React, { useRef, useEffect, useCallback, useState} from 'react';
import OutputNode from "components/pulled/OutputNode.js";
import CirklonEditor from "components/cirklon/CirklonEditor.js";
import StepsContainer from "components/v2/StepsContainer.js";
import Colors from "components/Colors.js";
import TrackThumbnail from "components/TrackThumbnail.js";
import {connect} from 'react-redux';
import {
    mouseDown,
    setSelectedPianoRollSteps,
    setStepsSelection,
    setStepNumberDraggingFrom
} from 'actions/index.js';

const colors = new Colors();

const MiniTrackComponent = ({
    track,
    id,
    isSelectedTrack,
    resolution,
    mouseDown,
    setSelectedPianoRollSteps,
    setStepsSelection,
    onTrackRendered,
    setStepNumberDraggingFrom,
    isHiding,
    setIsHiding,
    sequencerScale,
    muted,
    trackLength
}) => { 
    const ref = useRef(undefined);
    let borderColor = "#353535c7";
    let color = colors.getColorForTrack(track);
    let trackColor = colors.brighten(id === undefined ? borderColor : color, 0.64);
    let sequencerEngine =track.sequencerEngine;


    useEffect(() => {
        setTimeout(() => {
            onTrackRendered(track, ref);
        }, 100);
    }, [trackLength]);

    const onMouseUp = useCallback(() => {
        mouseDown(false);
        let state = sequencerEngine.store.getState();
        let selection = state.steps.stepsSelection;
        if (selection !== undefined && selection.toStep - selection.fromStep > 0) {
            let pattern = track.getEasyPattern();
            let selectedSteps = pattern.getSelectedSteps(selection, resolution);
            if (selectedSteps.length === 0) {
                setSelectedPianoRollSteps(
                    undefined);
            } else {
                setSelectedPianoRollSteps(
                    selectedSteps);
            }
        }

        setStepsSelection(undefined);
        setStepNumberDraggingFrom(undefined);
    }, [track, resolution]);

    const selectTrack = useCallback((e) => {
        track.sequencerEngine.selectTrack(track.trackNumber);
    }, [track]);

    const toggleHiding = useCallback(() => {
        setIsHiding(isHiding === track ? undefined : track);
    }, [isHiding, setIsHiding]);

    let showCirklon = isHiding === track;

    if (isHiding && isHiding !== track) {
        return [];
    }
    let style = {};
    if (sequencerScale) {
        // style.transform = 'scale(' + sequencerScale + ')';
        // style.marginBottom = sequencerScale * 10;
    }

    let className = "track";
    if (isHiding) {
        className += " hiding";
    }
    if (isSelectedTrack) {
        className += " selected";
    } else {
        className += " not-selected";
    }
    if (muted) {
        className += " muted";
    }
    
    return (
        <div
          ref={ref}
          style={style}
          onMouseUp={onMouseUp}
          className={className}>
        <div className="track-inner">
             <TrackThumbnail 
               hasBorder={true}
               isSelectedTrack={isSelectedTrack}
               onMouseDown={(e) => {
                   e.stopPropagation();
                   selectTrack();
               }}
               track={track}
               sample={track.sample}
               onClickThumbnail={toggleHiding}/>
        {showCirklon ?
         <CirklonEditor
           color={trackColor}
           track={track} /> :
          <StepsContainer
            sequencerScale={sequencerScale}
            key={1}
            isSelectedTrack={isSelectedTrack}
            sequencerEngine={track.sequencerEngine}
            store={track.sequencerEngine.store}
            trackNumber={track.trackNumber}
            id={id}
            trackColor={trackColor}
            sample={track.sample}
            track={track}
            isMini={true}
            trackData={track}
          />}
        </div>
          <div
            style={{color: color}}
            className="delete-track-trash"
            onClick={() => track.sequencerEngine.deleteTrack(track.trackNumber)}>x</div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let isSelectedTrack =state.mix.selectedTrack === props.track.trackNumber; 
    let track = props.track;
    let _track = track;
    if (track && track.tracks && track.tracks[0]) {
        _track = track.tracks[0].track;
    }
    return {
        trackId: track.id,
        id: _track.presetName ? _track.presetName :
            _track.sample !== undefined && _track.sample.getId() !== undefined ?
            _track.sample.getId() :
            _track.getName(),
        isSelectedTrack,
        resolution: state.sequencer.displayResolution,
        muted: state.tracks.trackMutes[props.track.id],
        trackLength: track.length
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setStepNumberDraggingFrom: (stepNumber) => dispatch(setStepNumberDraggingFrom(stepNumber)),
      setSelectedPianoRollSteps: (steps) => dispatch(setSelectedPianoRollSteps(steps)),
      setStepsSelection: (steps) => dispatch(setStepsSelection(steps)),
      mouseDown: m => dispatch(mouseDown(m)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniTrackComponent);
